// examples...
// if str is FeasibilityReport, return Feasibility Report
// if str is feasibility-report, return Feasibility Report
// if str is feasibility_report, return Feasibility Report
// if str is SmartUrl_ew-q, return Smart Url Ew Q
// if str is SMART_URL_EW-Q, return Smart Url Ew Q (needs toLowerCase)

export function transformToTitleCase(str: string): string {
  try {
    if (!str || str?.trim()?.length === 0) return str;

    return str
      .replace(/([a-z])([A-Z])|[-_]/g, '$1 $2') // Split camelCase and replace separators
      .toLowerCase() // Ensures consistent capitalization
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
  } catch (err) {
    console.error('transformToTitleCase failed due to', err);
    return str;
  }
}
